/**
 * Polish złoty.
 */
export var PLN = {
  code: 'PLN',
  base: 10,
  exponent: 2
};